module.exports = "<chat-users [users]=\"users\"></chat-users>\r\n<chat-body [messages]=\"messages\"></chat-body>\r\n<chat-form></chat-form>\r\n"